import { combineReducers } from "redux";
import { ColorThemeReducer } from "./reducers/ColorThemeReducer";
import { AudioReducer } from "./reducers/AudioReducer";


export const rootReducer = combineReducers({
  theme: ColorThemeReducer,
  audio: AudioReducer,
});
